<div class="mentions-block">
  <ng-container *ngIf="notifications.length > 0">
    <app-notification *ngFor="let notification of notifications" [userNfs]="notification"
                      [notificationOP]="notificationOP"></app-notification>
  </ng-container>
</div>

<div class="nf-footer">
  <div class="nf-other" [routerLink]="['/mentions']" (click)="openNFPage()">
    View all mentions
  </div>
</div>
